import * as OrdersActions from './orders.actions';
import * as fromOrders from './orders.reducers';
import * as OrdersSelectors from './orders.selectors';
import { Injectable } from '@angular/core';
import { Store, select, Action } from '@ngrx/store';
import { IOrderDetailsDTO } from '@care-portals/api-interfaces';

@Injectable()
export class OrdersFacade {
  constructor(private store: Store<fromOrders.State>) {}

  ordersState$ = this.store.pipe(select(OrdersSelectors.selectOrdersState));
  currentOrderState$ = this.store.pipe(
    select(OrdersSelectors.selectCurrentOrder)
  );
  orderDetails$ = this.store.pipe(select(OrdersSelectors.selectOrderDetails));
  orders$ = this.store.pipe(select(OrdersSelectors.getOrders));
  subscriptionsState$ = this.store.pipe(
    select(OrdersSelectors.selectSubscriptions)
  );
  modalState$ = this.store.pipe(select(OrdersSelectors.selectOrdersModal));
  isLoading$ = this.store.pipe(select(OrdersSelectors.isLoading));

  dispatch(action: Action) {
    this.store.dispatch(action);
  }

  payInvoiceWithPaymentMethod(invoiceId: string, paymentMethodId: string) {
    this.dispatch(
      OrdersActions.payInvoiceWithPaymentMethod({ invoiceId, paymentMethodId })
    );
  }

  openPayOrderModal(order: IOrderDetailsDTO) {
    this.dispatch(OrdersActions.openOrderPayModal({ order }));
  }

  closePayOrderModal() {
    this.dispatch(OrdersActions.closeOrderPayModal());
  }

  getOrders(v: 1 | 2 = 2) {
    this.dispatch(OrdersActions.getOrders({ v }));
  }

  openOrdersDetails(orderId: number) {
    this.dispatch(OrdersActions.openOrderDetails({ orderId }));
  }
  openOrdersModal() {
    this.dispatch(OrdersActions.openOrdersModal());
  }
  closeOrdersModal() {
    this.dispatch(OrdersActions.closeOrdersModal());
  }
}
